import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import td from './td';
import th from './th';
import tr from './tr';

import './styles.scss';

export default function VoucherEditorTable({ className, empty, readOnly, stickyActions, ...props }) {
  // TODO: Clean up no-content
  // TODO: Consider not using .form-data-table at all? Lots of overrides in editor.scss
  return (
    <div className={classNames('form-data-table', { 'no-content': empty, 'sticky-actions': stickyActions })}>
      <table
        className={classNames('voucher-editor-table', className, { 'read-only': readOnly })}
        {...props}
      />
    </div>
  );
}

VoucherEditorTable.propTypes = {
  className: PropTypes.string,
  empty: PropTypes.bool,
  readOnly: PropTypes.bool,
  stickyActions: PropTypes.bool,
};

VoucherEditorTable.td = td;
VoucherEditorTable.th = th;
VoucherEditorTable.tr = tr;
